import React from 'react';
import { motion } from 'framer-motion';
import { Ruler, Maximize2 } from 'lucide-react';
import { StandardSelect } from '@/components/ui/form-fields';
import styles from '../FilterBar.module.css';

interface DimensionsSelectorProps {
  width: string;
  height: string;
  onWidthChange: (value: string | string[]) => void;
  onHeightChange: (value: string | string[]) => void;
}

const DimensionsSelector: React.FC<DimensionsSelectorProps> = ({
  width,
  height,
  onWidthChange,
  onHeightChange
}) => {
  // Dimension options
  const dimensionOptions = [
    { value: '256', label: '256px' },
    { value: '512', label: '512px' },
    { value: '768', label: '768px' },
    { value: '1024', label: '1024px' },
  ];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3, delay: 0.1 }}
    >
      <div className="mb-3">
        <h3 className="text-sm font-medium mb-1 text-purple-600 dark:text-purple-400">Dimensions</h3>
      </div>
      
      <div className="">
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 gap-4">
          <div>
            <div className="text-left">
              <label className="text-xs font-medium text-gray-600 dark:text-gray-300 mb-1 inline-block">
                Width
              </label>
            </div>
            <StandardSelect
              id="width"
              label="Width"
              icon={<Maximize2 size={16} />}
              colorVariant="blue"
              value={width}
              onChange={onWidthChange}
              options={dimensionOptions}
              placeholder="Width"
              className={styles.vibrantInput}
            />
          </div>
          <div>
            <div className="text-left">
              <label className="text-xs font-medium text-gray-600 dark:text-gray-300 mb-1 inline-block">
                Height
              </label>
            </div>
            <StandardSelect
              id="height"
              label="Height"
              icon={<Maximize2 size={16} />}
              colorVariant="blue"
              value={height}
              onChange={onHeightChange}
              options={dimensionOptions}
              placeholder="Height"
              className={styles.vibrantInput}
            />
          </div>
        </div>
        
        {/* Dimensions display section removed as requested */}
      </div>
    </motion.div>
  );
};

export default DimensionsSelector;
